import { Field, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class SyncOfflineTicketsArgs extends ActionArgs {
  @Field(() => String)
  tickets: string
}

@ObjectType()
@InputType('SyncOfflineTicketsResultInput')
export class SyncOfflineTicketsResult {
  @Field(() => Boolean)
  success: boolean
}
